import React, { useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap"
import { FaPlus, FaX } from "react-icons/fa6"
import Configs from "../../config"
import { FetchPostData } from "utils/Common_api_functions"
import Loader from "components/Loader/loader"
import Swal from "sweetalert2"

const AddClubModal = ({ isOpen, toggle, onSuccess }) => {
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    clubName: "",
    clubThemeColor: "#000000",
    clubFontColor: "#ffffff",
    clubDescription: "",
    clubImage: null,
  })

  const [errors, setErrors] = useState({})
  const [imagePreview, setImagePreview] = useState(null)

  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleImageChange = e => {
    const file = e.target.files[0]
    setFormData(prev => ({ ...prev, clubImage: file }))

    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setImagePreview(reader.result)
      }
      reader.readAsDataURL(file)
    } else {
      setImagePreview(null)
    }
  }

  const validate = () => {
    const newErrors = {}
    if (!formData.clubName.trim()) newErrors.clubName = "Club name is required"
    if (!formData.clubThemeColor)
      newErrors.clubThemeColor = "Theme color is required"
    if (!formData.clubFontColor)
      newErrors.clubFontColor = "Font color is required"
    if (!formData.clubImage) newErrors.clubImage = "Club image is required"
    if (!formData.clubDescription.trim())
      newErrors.clubDescription = "Description is required"

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async () => {
    if (!validate()) return

    const APIData = await FetchPostData(setLoading, "/club", formData)

    if (APIData?.data?.success) {
      Swal.fire({
        title: "Club Added Successfully",
        icon: "success",
      })
      setFormData({
        clubName: "",
        clubThemeColor: "#000000",
        clubFontColor: "#ffffff",
        clubDescription: "",
        clubImage: null,
      })
      setImagePreview(null);
      toggle()
      onSuccess()
    } else {
      Swal.fire({
        title: "Something Went Wrong",
        text: APIData?.response?.data?.message,
        icon: "error",
      })
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      {loading && <Loader />}
      <ModalHeader toggle={toggle}>Add Club</ModalHeader>
      <ModalBody>
        {/* Club Name */}
        <Row className="mb-3">
          <Col xl="12">
            <Label>Club Name <span className="text-danger">*</span></Label>
            <Input
              type="text"
              name="clubName"
              value={formData.clubName}
              onChange={handleChange}
              placeholder="Enter Club Name"
              invalid={!!errors.clubName}
            />
            {errors.clubName && (
              <div className="text-danger">{errors.clubName}</div>
            )}
          </Col>
        </Row>

        {/* Club Image */}
        <Row className="mb-3">
          <Col xl="12">
            <Label>Club Image <span className="text-danger">*</span></Label>
            <Row>
              <Col md="8">
                <Input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  invalid={!!errors.clubImage}
                />
                {errors.clubImage && (
                  <div className="text-danger">{errors.clubImage}</div>
                )}
              </Col>
              <Col md="4" className="d-flex align-items-end">
                {imagePreview && (
                  <img
                    src={imagePreview}
                    alt="Preview"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "5px",
                    }}
                  />
                )}
              </Col>
            </Row>
          </Col>
        </Row>

        {/* Theme Color */}
        <Row className="mb-3">
          <Col xl="6">
            <Label>Theme Color <span className="text-danger">*</span></Label>
            <Row>
              <Col md="2" className="pe-0">
                <Input
                  type="color"
                  name="clubThemeColor"
                  value={formData.clubThemeColor}
                  onChange={handleChange}
                  style={{ width: "100%", height: "38px" }}
                  invalid={!!errors.clubThemeColor}
                />
              </Col>
              <Col md="10" className="ps-0">
                <Input
                  type="text"
                  name="clubThemeColor"
                  value={formData.clubThemeColor}
                  onChange={handleChange}
                  invalid={!!errors.clubThemeColor}
                />
              </Col>
            </Row>
            {errors.clubThemeColor && (
              <div className="text-danger">{errors.clubThemeColor}</div>
            )}
          </Col>

          {/* Font Color */}
          <Col xl="6">
            <Label>Font Color <span className="text-danger">*</span></Label>
            <Row>
              <Col md="2" className="pe-0">
                <Input
                  type="color"
                  name="clubFontColor"
                  value={formData.clubFontColor}
                  onChange={handleChange}
                  style={{ width: "100%", height: "38px" }}
                  invalid={!!errors.clubFontColor}
                />
              </Col>
              <Col md="10" className="ps-0">
                <Input
                  type="text"
                  name="clubFontColor"
                  value={formData.clubFontColor}
                  onChange={handleChange}
                  invalid={!!errors.clubFontColor}
                />
              </Col>
            </Row>
            {errors.clubFontColor && (
              <div className="text-danger">{errors.clubFontColor}</div>
            )}
          </Col>
        </Row>

        {/* Description */}
        <Row className="mb-3">
          <Col xl="12">
            <Label>Description <span className="text-danger">*</span></Label>
            <Input
              type="textarea"
              name="clubDescription"
              value={formData.clubDescription}
              onChange={handleChange}
              rows={4}
              placeholder="Enter Description"
              invalid={!!errors.clubDescription}
            />
            {errors.clubDescription && (
              <div className="text-danger">{errors.clubDescription}</div>
            )}
          </Col>
        </Row>
      </ModalBody>

      <ModalFooter>
        <Button color="primary" onClick={handleSubmit}>
          <FaPlus className="me-1" size={14} />
          Submit
        </Button>
        <Button color="danger" onClick={toggle}>
          <FaX className="me-1" size={14} />
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default AddClubModal
